import { original } from '@reduxjs/toolkit';
import { months, updateParentTotals, applyRowDeltaToParents } from '../utils/budgetHierarchyUtils';

export const MAX_EDIT_HISTORY = 50;
export const EMPTY_LIST = [];

export const snapshotRow = (row) => ({
    id: String(row.id),
    values: months.reduce((acc, m) => { acc[m] = row[m]; return acc; }, {}),
});

export const pushEditHistory = (state, rows) => {
    if (!rows || rows.length === 0) return;
    if (!state.editHistory) state.editHistory = [];
    state.editHistory.push({ rows: rows.map(snapshotRow) });
    if (state.editHistory.length > MAX_EDIT_HISTORY) state.editHistory.shift();
};

export const findRowIndex = (state, id) => original(state.budgetData).findIndex(row => String(row.id) === String(id));

export const markRowDirty = (state, row) => {
    const id = String(row.id);
    const territoryId = String(row.territoryId);
    state.isDirty = true;
    if (!state.dirtyRowIds.map(String).includes(id)) state.dirtyRowIds.push(id);
    if (territoryId && !state.dirtyRowIds.map(String).includes(territoryId)) state.dirtyRowIds.push(territoryId);
    if (state.invalidRowIds.includes(id)) state.invalidRowIds = state.invalidRowIds.filter(x => x !== id);
};

export const addCellHistory = (state, rowId, month, oldValue, newValue, user) => {
    const key = `${rowId}-${month}`;
    if (!state.cellHistory[key]) state.cellHistory[key] = [];
    state.cellHistory[key].unshift({ date: new Date().toLocaleString(), oldValue, newValue, user });
    if (state.cellHistory[key].length > 5) state.cellHistory[key].pop();
};

export const syncParentTotals = (state, changes) => {
    for (const { row, before } of changes) {
        if (!applyRowDeltaToParents(state.budgetData, row, before)) {
            updateParentTotals(state.budgetData);
            return;
        }
    }
};
